import styled from 'styled-components';

export const ManagedWorkspace = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl}px;
  min-width: 0;
`;

export const WorkspacePanel = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.spacing.lg}px;
  border: thin solid ${({ theme }) => theme.colors.grey_1};
  background: ${({ theme }) => theme.colors.white_1};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding: ${({ theme }) => theme.spacing.md}px;
  }
`;

export const ConversationSection = styled.section`
  min-width: 0;
  padding-bottom: ${({ theme }) => theme.spacing.xxl}px;
`;
